module.exports = __webpack_public_path__ + "static/media/Rectangle 410.e36e1b3c.png";